import moment from 'moment';
import { Channel } from '../../../types/channel.types';
import UserLinkButton from '../../button/user-link.button';
import HorizontalBar from '../../horizontalBar';
import CoverImage from '../../images/cover.image';
import { HStack, VStack } from '../../layouts/stack.layout';
import { IconTextGroup } from '../../typography/v2/icon-text-group';
import { TextGroup } from '../../typography/v2/text-group';
import { TagsContainer } from '../tags.container';

type Props = {
  channel: Channel;
};

export default function ChannelInfoCardContainer({ channel }: Props) {
  return (
    <VStack gap="base">
      {channel.title && channel.backgroundImage && (
        <CoverImage alt={channel.title} src={channel.backgroundImage} />
      )}
      {channel.administrator && (
        <UserLinkButton
          to={channel.administrator.username}
          user={channel.administrator}
        />
      )}
      <TagsContainer tags={channel.tags} />
      <VStack extensions="w-full" gap="sm">
        <HorizontalBar />
        <HStack justify="between" extensions="w-full">
          <IconTextGroup
            iconFirst
            icon="person"
            text={`${channel.listeners.length} listeners`}
          />
          <IconTextGroup
            iconFirst
            icon="events"
            text={`Created ${moment().subtract(10, 'd').format('LL')}`}
          />
        </HStack>
        <HorizontalBar />
        <IconTextGroup
          iconFirst
          text={channel.isPrivate ? 'Private Channel' : 'Open Channel'}
          icon={channel.isPrivate ? 'locked' : 'unlocked'}
        />
        <HorizontalBar />
      </VStack>
      <TextGroup heading="Description" subheading={channel.description} />
    </VStack>
  );
}
